import React from "react";
import PropTypes from "prop-types";

export default class Rating extends React.Component {
  componentWillMount() {
    this.setStateFromProps(this.props);
  }

  // componentWillReceiveProps(nextProps) {
  //   this.setStateFromProps(nextProps)
  // }

  setStateFromProps(props) {
    this.setState({
      value: props.value,
    });
  }

  rate(el, mx) {
    const { left: x, width: w } = el.getBoundingClientRect();
    // 只能1、2、3、4、5星，不允许4.5这种的
    const value = Math.min(50, Math.max(10, (+`${Math.floor(((mx - x) / w) * 50)}`.slice(-2, -1) + 1) * 10));
    this.setState({ value });
    this.props.onRate(this.props.id, value);
  }

  render() {
    const { value } = this.state;
    const { readonly, className } = this.props;
    return (
      <button
        className={`rating-stars ${className}`}
        disabled={readonly}
        onClick={evt => this.rate(evt.currentTarget, evt.clientX)}
      >
        <i
          className="rating-star stared"
          style={{
            width: `${value * 2}%`,
          }}
        />
        <i className="rating-star unstared" />
      </button>
    );
  }
}

const { string, number, bool, func } = PropTypes;
const propTypes = {
  id: number, // 可评分时，需要该id，传入scoreItemId
  className: string,
  value: number,
  readonly: bool,
  onRate: func,
};
const defaultProps = {
  id: -1,
  className: "",
  value: 0,
  readonly: true,
  onRate: () => null,
};

Rating.propTypes = propTypes;
Rating.defaultProps = defaultProps;

require("./index.less");
require("./index.less");